import PageIntro from '../components/PageIntro';

export default function Terms() {
  return (
    <div className="page-shell space-y-8">
      <PageIntro
        eyebrow="Terms"
        title="Terms of service presented in a way that is easy to scan."
        description="Even basic legal content should match the rest of the site visually, with enough structure to feel intentional and dependable."
      />

      <section className="section-card-strong p-8">
        <div className="legal-stack">
          <article className="legal-panel">
            <h2 className="mb-3 text-3xl text-primary-dark">Acceptance of terms</h2>
            <p className="section-copy text-base">
              By accessing and using the Victoria's Place website and services, you agree to these
              terms and any related policies referenced here.
            </p>
          </article>
          <article className="legal-panel">
            <h2 className="mb-3 text-3xl text-primary-dark">Use of services</h2>
            <p className="section-copy text-base">
              Visitors agree to use the site lawfully and in ways that do not interfere with the
              rights, safety, or use of others.
            </p>
          </article>
          <article className="legal-panel">
            <h2 className="mb-3 text-3xl text-primary-dark">Donations</h2>
            <p className="section-copy text-base">
              Donations are generally final unless otherwise stated and are intended to be processed
              securely through Stripe once payment integration is completed.
            </p>
          </article>
          <article className="legal-panel">
            <h2 className="mb-3 text-3xl text-primary-dark">Contact us</h2>
            <p className="section-copy text-base">
              If you have questions about these terms, use the contact page to reach the team.
            </p>
          </article>
        </div>

        <p className="mt-8 text-sm font-medium text-slate-500">
          Last updated: {new Date().toLocaleDateString()}
        </p>
      </section>
    </div>
  );
}
